import { observable, action, makeObservable } from 'mobx';
import { AlertColor } from '@mui/lab';

export class SnackbarModel {
    @observable
    public isOpen: boolean;
    @observable
    public autohideDuration: number;

    @observable
    public Component?: JSX.Element;
    @observable
    public message?: string;
    public severity?: AlertColor;

    constructor(isOpen: boolean = false, autohideDuration: number = 6000) {
        this.isOpen = isOpen;
        this.autohideDuration = autohideDuration;
        makeObservable(this);
    }

    @action
    show(Component: JSX.Element, autohideDuration: number = 6000) {
        this.isOpen = true;
        this.Component = Component;
        this.autohideDuration = autohideDuration;

        this.message = undefined;
    }

    @action
    showMessage(severity: AlertColor, message: string) {
        this.isOpen = true;
        this.severity = severity;
        this.message = message;

        this.Component = undefined;
    }

    @action
    hide() {
        this.isOpen = false;
    }
}

export default SnackbarModel;
